const section = document.querySelector('.concierge-section-five');
if (section) {
    const textarea = section.querySelector('textarea[name="message"]');
    const counter = section.querySelector('.concierge-section-five__counter');

    if (textarea && counter) {
        const max = parseInt(textarea.getAttribute('maxlength'), 10) || 1000;

        function updateCounter() {
            counter.textContent = `${textarea.value.length}/${max} CARACTÈRES`;
        }

        textarea.addEventListener('input', updateCounter);
        updateCounter();
    }
}
